import { Injectable } from '@angular/core';
import { Jrpc } from '@lentau/api/services/jrpc/jrpc.service';
import { AddressesApiParserService } from './addresses-api-parser.service';
import { UserAddressResponseBody, UserAddress } from '@lentau/address/shared/interfaces';
import { ResponseJrpcDto } from '@lentau/api/shared/jrpc/types';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AddressesApiService {
  constructor(
    private jrpc: Jrpc,
    private addressesApiParserService: AddressesApiParserService
  ) {}

  public userMercuryAddressSearch(): Observable<UserAddress[]> {
    return this.jrpc.post('userMercuryAddressSearch').pipe(
      map((data: ResponseJrpcDto<{ response: UserAddressResponseBody }>) => {
        return this.addressesApiParserService.parseUserAddressResponse({ Body: data.result.response });
      })
    );
  }
}
